/* eslint-disable @typescript-eslint/naming-convention */
import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'
import { withLoadingReducer } from 'utils/reducerHandler'
import {
  GetProductInventoriesParamsType,
  ProductInventoryItemType,
} from 'features/Product/services/inventory'
import {
  fetchGetWarehouseLocations,
  fetchGetProductWarehouse,
  fetchPutInventoryLocationStatus,
  fetchPutInventoryLocation,
  SLICE_NAME,
} from './thunk'

export type ConstantType = {
  id: number
  name: string
}

export type WarehouseStateType = {
  isLoading: boolean
  query: GetProductInventoriesParamsType
  constants: {
    locations: ConstantType[]
  }
  pagination: {
    page_size: number
    page_index: number
    direction: 'asc' | 'desc'
    sort: string
  }
  data: (ProductInventoryItemType & {
    cid: string
  })[]
}

const initialState: WarehouseStateType = {
  isLoading: false,
  query: {
    'pagination.page_index': 1,
  },
  constants: {
    locations: [],
  },
  pagination: {
    page_size: 20,
    page_index: 1,
    direction: 'asc',
    sort: '',
  },
  data: [],
}

const warehouseSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<WarehouseStateType>) => {
      builder
        .addCase(fetchGetProductWarehouse.pending, (state, action) => {
          state.query = {
            ...state.query,
            ...action.meta.arg,
          }
        })
        .addCase(fetchGetProductWarehouse.fulfilled, (state, action) => {
          const {
            data,
            pagination: { direction, page_index, page_size, sort },
          } = action.payload

          state.data = data.map((item) => ({ ...item, cid: uuidv4() }))
          state.pagination = {
            page_size,
            direction,
            page_index,
            sort,
          }
        })
        // =====
        .addCase(fetchGetWarehouseLocations.fulfilled, (state, action) => {
          state.constants.locations = action.payload.map((loc) => ({
            id: loc.location_id,
            name: loc.location_name,
          }))
        })
    },
    [fetchGetProductWarehouse, fetchPutInventoryLocationStatus, fetchPutInventoryLocation],
  ),
})

export const { reset } = warehouseSlice.actions
export default warehouseSlice.reducer
